import { useEffect, useState } from 'react'

interface IUseUnrollProps {
  unrolls: string[]
  isUnroll: (id: number | string) => boolean
  changeUnroll: (id: number | string) => void
  changeAllUnroll: (list: object[], key: string) => void
}
type UseUnrollProps = IUseUnrollProps

export const useUnroll = (): UseUnrollProps => {
  const [unrolls, setUnrolls] = useState<string[]>([])

  useEffect(() => {
    return () => {
      setUnrolls([])
    }
  }, [])

  const isUnroll = (id: number | string): boolean => {
    let repeat = false

    if (unrolls.length > 0) {
      unrolls.forEach((object) => {
        if (String(object) === String(id)) {
          repeat = true
        }
      })
    }

    return repeat
  }

  const changeUnroll = (id: number | string): void => {
    let repeat = false

    if (unrolls.length > 0) {
      unrolls.forEach((object, index) => {
        if (String(object) === String(id)) {
          repeat = true
          unrolls.splice(index, 1)
        }
      })
    }

    if (!repeat) {
      unrolls.push(String(id))
    }

    setUnrolls([...unrolls])
  }

  const changeAllUnroll = (list: object[], key: string): void => {
    const unroll: string[] = []
    if (list.length !== unrolls.length) {
      list.forEach((object: Record<string, any>): void => {
        unroll.push(String(object[key]))
      })
    }

    setUnrolls([...unroll])
  }

  return {
    unrolls,
    isUnroll,
    changeUnroll,
    changeAllUnroll
  }
}
